module.exports = __webpack_public_path__ + "shuye_banner.png?0a64edc007f8ec4f62f73ffa8361f8b1";